import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '@paypalcorp/pp-react';
import EnvSetUp from './EnvSetUp/EnvSetUp';
import KnowBefore from './KnowBefore/KnowBefore';
import Resources from './Resources/Resources';
import styles from './SetUpInfo.module.less';
import MultiLangEnvSetup from './MultiLangEnvSetup';

const SetUpInfo = ({ ecmContent }) => {
  const { pageContent } = ecmContent;
  if (!pageContent) {
    return <></>;
  }

  let multiDevEnv;
  let devEnv;
  let knowBeforeCards;
  let resourceCards;
  pageContent.forEach((content) => {
    const key = content?.key;
    if (key === 'devEnvSetup') {
      devEnv = content;
    } else if (key === 'knowBeforeSection') {
      knowBeforeCards = content;
    } else if (key === 'resourcesSection') {
      resourceCards = content;
    } else if (key === 'multiLangDevEnvSetup') {
      multiDevEnv = content;
    }
  });

  return (
    <div className={`${styles.page_container}`}>
      <Row className={`${styles.bottom_content}`}>
        <Col xs={12} md={8}>
          {multiDevEnv ? (
            <MultiLangEnvSetup multiEnv={multiDevEnv.contents} title={multiDevEnv.title} />
          ) : (
            <EnvSetUp devEnv={devEnv.contents} title={devEnv.title} />
          )}
        </Col>
        <Col xs={12} md={4}>
          <KnowBefore knowBeforeCards={knowBeforeCards} />
          <Resources resourceCards={resourceCards} />
        </Col>
      </Row>
    </div>
  );
};

SetUpInfo.propTypes = {
  ecmContent: PropTypes.object.isRequired
};

export default SetUpInfo;
